import { render } from "./CadastroVeiculoTrator.vue?vue&type=template&id=7f6a4e7a&scoped=true"
import script from "./CadastroVeiculoTrator.vue?vue&type=script&lang=ts"
export * from "./CadastroVeiculoTrator.vue?vue&type=script&lang=ts"

import "./CadastroVeiculoTrator.vue?vue&type=style&index=0&id=7f6a4e7a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7f6a4e7a"

export default script